'use strict';

angular.module('app.updateEngagementScores', [])
	.controller('updateEngagementScoresCtrl', ['$scope', '$modalInstance', '$modal', 'updateEngagementScoresService',
		function ($scope, $modalInstance, $modal, updateEngagementScoresService) {
		    
		    $scope.confirmUpdateEngagementScores = function () {
		        $scope.engagementScores = [];
		        $scope.engagementScoresBlog.forEach(function(item){
		            $scope.engagementScores.push(item);
		        })
		        $scope.engagementScoresInstagram.forEach(function(item){
		            $scope.engagementScores.push(item);
		        })
		        $scope.engagementScoresYoutube.forEach(function(item){
		            $scope.engagementScores.push(item);
		        })
		        $scope.engagementScoresFacebook.forEach(function(item){
		            $scope.engagementScores.push(item);
		        })
						$scope.engagementScoresTiktok.forEach(function(item){
							$scope.engagementScores.push(item);
						})
		        
		        var params = {
		            data: $scope.engagementScores
		        }

		        updateEngagementScoresService.updateEngagementScores(params, true)
		        	.then(function(response) {
		        		$modalInstance.close(function () {
			                $log.info('Close Modal now');
			            })
		        	}, function(response) {
		        		var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
		        	})
		    }
		    
		    $scope.closeModal = function(){
		        $modalInstance.close();    
		    }
}])